export default __webpack_public_path__ + "static/media/9-mountains-bg-back.53b9b7ac.png";